import { Grid } from "antd";
import { withConditionalComponent } from "src/HOC/WithMobileComponent";
import { MOBILE_BREAKPOINT_KEY } from "src/constants";
import PointsExchangeSkeletonWeb from "./layouts/PointsExchangeSkeleton.web";
import PointsExchangeSkeletonMob from "./layouts/PointsExchangeSkeleton.mob";

const PointsExchangeSkeletonComponent = withConditionalComponent(PointsExchangeSkeletonWeb, PointsExchangeSkeletonMob);

export default function PointsExchangeSkeleton() {
  const isLargeScreen = !!Grid.useBreakpoint()[MOBILE_BREAKPOINT_KEY];

  return <PointsExchangeSkeletonComponent trigger={isLargeScreen} />;
}
